// Employee Handbook — West Coral Communications LLC (key sections).
// Full original document is downloadable at /handbook/handbook.docx
export const HANDBOOK_UPDATED = "Last updated July 20, 2026";

export const HANDBOOK = [
  {
    title: "Foreword",
    body: [
      "Congratulations and welcome to West Coral Communications. Whether you have recently joined our team or have worked with us for some time, we are excited to work with you. Your performance will be integral to West Coral Communications' future success.",
      "This Employee Handbook informs you of the essential aspects of your employment. It is not an employment contract, and nothing in it gives you any right, express or implied, to continued employment. All terms, conditions, policies, and procedures are subject to change.",
      "As an employee, you must keep the information provided in this Handbook confidential. Please review it thoroughly and pass any questions to your immediate supervisor.",
      "— Chad, President",
    ],
  },
  {
    title: "1.1  Who Are We?",
    body: [
      "West Coral Communications specializes in the installation and repair of telecommunications infrastructure, focusing on fiber optic and telecom services.",
      "Fiber Optic Installation: comprehensive solutions for fiber deployments, ensuring high-speed, reliable connectivity for businesses and residential areas.",
      "Telecom Repair: skilled technicians manage repairs and maintenance to maintain the integrity and performance of telecom networks.",
      "Custom Solutions: tailored services for complex installations, including secure communication setups for sensitive environments.",
    ],
  },
  {
    title: "1.2  Our Core Values",
    body: [
      "Customer Commitment · Safety · Integrity · Respect · Teamwork · Entrepreneurship · Transparency · Leadership · Accountability · Trust · Ethics.",
      "These fundamental values guide our behavior in all aspects of our business activity. We operate consistently with our values and in compliance with our ethical principles and the law.",
    ],
  },
  {
    title: "1.3  Target-Zero Safety Beliefs & Rules",
    body: [
      "We believe all injuries, occupational illnesses, and environmental harm can be prevented. Nothing is so important or urgent that we cannot take the time to do it safely.",
      "Working safely is a condition of employment. You have the right and responsibility to refuse unsafe work.",
      "Target Zero Rules: Fit for Duty/Task (drug & alcohol-free, proper PPE); Incident Reporting (report all incidents immediately); Critical Task Review (review the JSA before a critical task); Energy Isolation (lock out/tag out/de-energize); Critical Safety Devices; Driving Safety (seat belts, no distracted driving); Working at Height (fall protection); Respect (work free from harassment).",
    ],
  },
  {
    title: "1.7  At-Will Employment",
    body: [
      "Unless expressly prohibited by statute, all employees without a written employment agreement to the contrary are employed on an \u201cat-will\u201d basis. Either the Company or the at-will employee may conclude the employment relationship with or without advance notice at any time and for any reason.",
    ],
  },
  {
    title: "2.9  Employment Eligibility (Form I-9)",
    body: [
      "In compliance with federal law, all new employees must complete USCIS Form I-9 no later than the first day of hire to verify identity and employment authorization.",
      "You will verify your identity and eligibility by providing documentation as specified on the form. The Company retains and stores the completed Form I-9 for three years after the date of hire or one year after employment is terminated, whichever is later.",
    ],
  },
  {
    title: "4.7  Dress Code (Work Site)",
    body: [
      "Your shirt must be a West Coral Communications high-vis crew shirt; if unavailable, any high-vis color shirt is acceptable. Baggy pants/cargo pants are not permitted.",
      "PPE must be worn at all times on-site: Hard Hat, Z87-certified Safety Glasses, Reflective Vest, Steel-Toed Lace-Up Boots, Gloves (optional), and Safety Belts (at all times while in a man-basket).",
    ],
  },
  {
    title: "4.8  Safety & OSHA",
    body: [
      "Each employee helps maintain a safe work environment and complies with all safety and health laws. Report all injuries, accidents, illnesses, safety hazards, and health concerns to a manager.",
      "OSHA requires records of all work-related accidents and illnesses. Submit an incident report for all accidents, illnesses, or unsafe conditions, no matter how small.",
    ],
  },
  {
    title: "4.11  Drug-Free Workplace",
    body: [
      "Employees are prohibited from consuming, possessing, selling, or purchasing illegal drugs at any time on Company property or while engaged in Company business, and may not have any detectable amount of alcohol or illegal drugs in their system at work.",
      "The Company may conduct random, reasonable-suspicion, pre-employment, and post-incident drug or alcohol testing. Violations may result in discipline up to and including termination.",
    ],
  },
  {
    title: "Employee Acknowledgment",
    body: [
      "By completing this onboarding you acknowledge that you have received a copy of this Employee Handbook and that it is your responsibility to read, understand, and comply with all policies contained in it — including policies on confidentiality, health, safety, anti-harassment, discrimination, and drugs and alcohol.",
      "You acknowledge this is an at-will employment relationship and not a contract or guarantee of continued employment, and that the Company may change these policies at any time.",
    ],
  },
];
